import { useMemo } from 'react';
import { useResponsive } from './use-responsive';

export interface ResponsiveValues<T> {
  base: T;
  sm?: T;
  lg?: T;
  xl?: T;
  xl2?: T;
  xl3?: T;
}
export const useResponsiveValue = <T>(value: ResponsiveValues<T>) => {
  const breakPoints = useResponsive();
  return useMemo(() => {
    if (breakPoints.xl3 && 'xl3' in value) return value.xl3;
    if (breakPoints.xl2 && 'xl2' in value) return value.xl2;
    if (breakPoints.xl && 'xl' in value) return value.xl;
    if (breakPoints.lg && 'lg' in value) return value.lg;
    if (breakPoints.sm && 'sm' in value) return value.sm;

    return value.base;
  }, [breakPoints, value]);
};
